/**
 * In-memory access token holder.
 *
 * The access token is short-lived and kept ONLY in memory (never localStorage —
 * XSS-safe). The refresh token lives in an httpOnly cookie the browser sends
 * automatically. On a hard reload memory is empty, so the app silently calls
 * /auth/refresh on boot to mint a fresh access token from the cookie.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
